import { Navigate, Outlet } from "react-router-dom";
import paths from "@/utils/paths";
import { getUserInfo } from "@/services/auth";

export default function AuthLayout() {
  const { data: user, isLoading } = getUserInfo();

  if (!isLoading && user) {
    return <Navigate to={paths.index} />;
  }

  return <Outlet />;
}
